import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    fechaDesde: { label: i18n.t('app.from'), value: '' },
    fechaHasta: { label: i18n.t('app.to'), value: '' },
    tipoImportacion: { label: i18n.t('imports.type'), value: '' },
    tipoImportacionEstado: { label: i18n.t('imports.status'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
    usuario: { label: i18n.t('users.entity_name'), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'idImportacion', width: '100px', minResizableWidth: 50, title: i18n.t('app.id'), hidden: false, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      minResizableWidth: 130,
      only: {
        roles: [3],
      },
    },
    {
      field: 'Cliente',
      width: '250px',
      minResizableWidth: 187,
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'idTipo', width: '400px', minResizableWidth: 200, title: i18n.t('imports.type'), columnMenu: 'myTemplate', locked: false, cell: 'enumTemplate', format: 'TIPOS_IMPORTACION' },
    // { field: 'idEstado', width: '250px', title: i18n.t('imports.id_status'), columnMenu: 'myTemplate', locked: false, hidden: true },
    { field: 'idEstado', width: '400px', minResizableWidth: 200, title: i18n.t('imports.status'), columnMenu: 'myTemplate', locked: false, cell: 'enumTemplate', format: 'TIPOS_IMPORTACION_ESTADO' },
    { 
      field: 'Fecha', 
      width: '300px', 
      minResizableWidth: 150,
      title: i18n.t('imports.fecha'), 
      columnMenu: 'myTemplate', 
      locked: false, 
      type: 'date',
      filter: 'date',
      format: 'numeric_datetime',
      cell: 'fechaTemplate',
      extraparams: { separators: { date: '-', datetime: ' ' } },
    },
    { field: 'Usuario', width: '350px', minResizableWidth: 175, title: i18n.t('users.entity_name'), columnMenu: 'myTemplate', locked: false },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      minResizableWidth: 100,
      locked: false 
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
